/**
 * Created by heshufen on 19/3/18.
 */
import React from 'react'
// import {Text, div, Image} from 'react-native'
import {Horizontal, Vertical, Image, Text} from "../../../components/index";

const monent = require('moment');
import {merge}from '../../../utils/uiUtils'

export default class ExamEnterView extends React.Component {
    showExamEnter() {
        return false;
    }

    isExam() {
        return this.props.userInfo.healthExamination.status === 2;
    }

    isPass() {
        return this.props.userInfo.healthExamination.level === 1;
    }

    isFinishStudy() {
        return this.props.userInfo.healthExamination.status === 1;
    }

    isNameApprove() {
        const {v = 0, annual} = this.props.ownerInfo;
        if (annual && annual.annual === 1) {
            return false;
        } else {
            return v === 1;
        }
    }

    isAllow() {
        const {allow = 0} = this.props.userInfo.healthExamination;
        return allow === 1;
    }

    renderResultImage() {
        if (this.isExam()) {
            if (this.isPass()) {
                return <Image style={styles.examIcon} resizeMode="contain"
                              source={require('../assets/icon-hege.png')}/>;
            } else {
                return <Image style={styles.examIcon} resizeMode="contain"
                              source={require('../assets/icon-buhege.png')}/>;
            }
        } else {
            return <Image style={styles.examIcon} resizeMode="contain"
                          source={require('../assets/icon-weikaoshi.png')}/>;
        }
    }

    renderUnExamContent() {
        return (
            <Vertical>
                <Text style={styles.examResult}>{this.showExamEnter() ? "暂未参与考试" : "此纹身师还未参加考试！"}</Text>
                {this.showExamEnter() && <div onClick={() => {
                    if (this.isAllow()) {
                        if (this.isFinishStudy()) {
                            this.props.navigation.push('Questions')
                        } else {
                            this.props.showStudyDialog()
                        }
                    } else {
                        this.props.showNameApproveDialog(1)
                    }
                }}>
                    <Text style={styles.exam}>立即考试</Text>
                </div>}
            </Vertical>
        );
    }

    renderExamContent() {
        let {examinationTime, examinationCostTime, score = 0} = this.props.userInfo.healthExamination;
        examinationTime = monent(examinationTime).format('YYYY年M月D日');
        examinationCostTime = Math.ceil(examinationCostTime / 60);
        return (
            <Vertical>
                <Text style={merge(contentStyles.title, contentStyles.marginBot)}>考试时间：{examinationTime}</Text>
                <Text style={merge(contentStyles.title, contentStyles.marginBot)}>考试用时：{examinationCostTime}分钟</Text>
                <Horizontal>
                    <Text style={contentStyles.title}>
                        考试成绩：
                        <Text style={contentStyles.resultTitle}>
                            {this.isPass() ? "合格" : score + "分"}
                        </Text>
                    </Text>
                    {this.showExamEnter() && !this.isPass() && <div onClick={() => {
                        if (this.isAllow()) {
                            this.props.navigation.push('Questions')
                        } else {
                            this.props.showNameApproveDialog(1)
                        }
                    }}>
                        <Text style={styles.reExam}>重新考试</Text>
                    </div>}
                </Horizontal>
            </Vertical>
        );
    }

    render() {
        return (
            <Vertical style={{}}>
                <Horizontal style={styles.titleContainer}>
                    <Text style={styles.title}>纹身卫生安全考试
                        <Text style={styles.title2}>（安全放心）</Text></Text>
                </Horizontal>
                <Vertical style={styles.container}>
                    <Horizontal style={styles.contentContainer}>
                        {this.renderResultImage()}
                        {this.isExam() ? this.renderExamContent() : this.renderUnExamContent()}
                    </Horizontal>
                </Vertical>
            </Vertical>
        );
    }
}

const contentStyles = {
    title: {
        fontFamily: "PingFangSC-Regular",
        fontSize: 14,
        color: "#4E4E4E"
    },
    marginBot: {
        marginBottom: 8,
    },
    resultTitle: {
        fontSize: 14,
        color: "#4E4E4E"
    }
}

const styles = {
    container: {
        marginLeft: 15,
        marginRight: 15,
        marginBottom: 15,
        borderRadius: 5,
        backgroundColor: "#f7f7f7",
    },
    titleContainer: {
        marginLeft: 15,
        marginTop: 5,
        marginBottom: 13,
        alignItems: 'center'
    },
    imageIcon: {
        width: 13,
        height: 13,
        marginRight: 10,
    },
    title: {
        fontSize: 16,
        color: "#232323"
    },
    title2: {
        fontSize: 13,
        color: "#999999"
    },
    line: {
        height: 1,
        backgroundColor: "#eeeeee"
    },
    contentContainer: {
        height: 124,
        alignItems: 'center'
    },
    examIcon: {
        width: 83,
        height: 83,
        marginLeft: 32,
        marginRight: 31,
    },
    examResult: {
        fontFamily: "PingFangSC-Regular",
        fontSize: 14,
        color: "#222"
    },
    exam: {
        marginTop: 10,
        fontFamily: "PingFangSC-Semibold",
        fontSize: 14,
        textDecorationLine: "underline",
        color: "#ff7700"
    },
    reExam: {
        marginLeft: 10,
        fontFamily: "PingFangSC-Semibold",
        fontSize: 14,
        textDecorationLine: "underline",
        color: "#ff7700",
    },
};



// WEBPACK FOOTER //
// ./src/apps/portfolio/screens/ExamResultView.js